export const fixUrlsInPosts = <T extends string | null | undefined>(s: T) =>
  s
    ? s
        .replace(
          /https:\/\/(wordpress\.)?hnavi\.co\.jp\/wp-content\/uploads\//g,
          `${
            process.env.NEXT_PUBLIC_WORDPRESS_URL || process.env.WORDPRESS_URL
          }/wp-content/uploads/`
        )
        .replaceAll(
          'https://wordpress.hnavi.co.jp/wp-content/themes/',
          `${
            process.env.NEXT_PUBLIC_WORDPRESS_URL || process.env.WORDPRESS_URL
          }/wp-content/themes/`
        )
        .replaceAll(
          'https://hnavi.co.jp/',
          `https://${
            process.env.NEXT_PUBLIC_FRONT_SERVICE_HOST ||
            process.env.FRONT_SERVICE_HOST
          }/`
        )
    : s;
